import React, { useEffect, useState } from "react";

// ---- CLARITY helper ----
const track = (name, props = {}) => {
  if (typeof window !== "undefined" && window.clarity) {
    window.clarity("event", name, props);
  }
};

const InfographicModalSection = () => {
  const [open, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
    track("infographic_open", { placement: "home", component: "InfographicModal" });
  };

  const closeModal = (method = "unknown") => {
    setOpen(false);
    track("infographic_close", { placement: "home", component: "InfographicModal", method });
  };

  // ESC to close + prevent background scroll
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeModal("esc_key");
    };

    if (open) {
      document.addEventListener("keydown", onKeyDown);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      {/* Section */}
      <section className="py-12 px-4 sm:px-6 bg-gradient-to-b from-[#0B1B3A] via-[#0A1020] to-black text-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl font-extrabold">
              How <span className="text-orange-400">myBOQ</span> Works
            </h2>
            <p className="text-gray-300 mt-3 max-w-2xl mx-auto">
              SSR-compliant estimation to export-ready reports — in a simple workflow.
            </p>
          </div>

          {/* Modern Preview Card */}
          <button
            type="button"
            onClick={openModal}
            className="group block w-full max-w-4xl mx-auto text-left"
            aria-label="Open myBOQ infographic"
          >
            <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur shadow-xl">
              {/* Cropped preview */}
              <div className="relative">
                <img
                  src="/myboq-infographic.png"
                  alt="myBOQ workflow infographic preview"
                  className="w-full h-auto block"
                  style={{
                    maxHeight: 420,
                    objectFit: "cover",
                    objectPosition: "top",
                  }}
                  loading="lazy"
                />
                {/* fade */}
                <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-black/90 to-transparent" />
              </div>

              {/* CTA overlay */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
                <span className="inline-flex items-center gap-2 bg-orange-500 text-white px-5 py-2 rounded-full text-sm font-semibold shadow group-hover:bg-orange-600 transition">
                  View Full Workflow →
                </span>
              </div>
            </div>

            <p className="text-center text-gray-300 text-sm mt-4">
              Tap to open (ESC to close)
            </p>
          </button>
        </div>
      </section>

      {/* Modal */}
      {open && (
        <div
          className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-3 sm:p-6"
          role="dialog"
          aria-modal="true"
          aria-label="myBOQ infographic modal"
          onMouseDown={(e) => {
            // click outside closes
            if (e.target === e.currentTarget) closeModal("backdrop");
          }}
        >
          <div className="relative w-full max-w-6xl bg-[#0A1020] rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
            {/* Top bar */}
            <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-b border-white/10">
              <div className="text-white font-semibold">myBOQ Workflow Infographic</div>

              <div className="flex items-center gap-2">
                {/* Open in new tab (optional) */}
                <a
                  href="/myboq-infographic.png"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs sm:text-sm font-semibold text-orange-300 hover:text-orange-200 underline"
                  onClick={() => track("infographic_open_new_tab", { placement: "home", component: "InfographicModal" })}
                >
                  Open in new tab
                </a>

                <button
                  onClick={() => closeModal("close_button")}
                  className="ml-2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white text-xl leading-none flex items-center justify-center"
                  aria-label="Close modal"
                >
                  ×
                </button>
              </div>
            </div>

            {/* Scrollable content (mobile friendly) */}
            <div className="p-3 sm:p-6 flex items-center justify-center">
            <img
  src="/myboq-infographic.png"
  alt="myBOQ workflow infographic"
  className="max-h-[85vh] w-auto max-w-full rounded-xl object-contain"
/>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InfographicModalSection;
